import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Alarm } from 'src/app/_models/alarm';
import { EflResult } from 'src/app/_models/efl-results';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsResultsService {

  constructor(
    private httpClient: HttpClient
  ) { }

  private sidebarOpen = new BehaviorSubject<boolean>(true);
  sidebarOpen$ = this.sidebarOpen.asObservable();

  private selectedTopologyId = new BehaviorSubject<string | null>(null);
  selectedTopologyId$ = this.selectedTopologyId.asObservable();
  private alarms = new BehaviorSubject<Array<Alarm>>([]);
  alarms$ = this.alarms.asObservable();
  private distinctTopologyIds = new BehaviorSubject<Array<string>>([]);
  distinctTopologyIds$ = this.distinctTopologyIds.asObservable();

  private eflResults = new BehaviorSubject<Array<EflResult>>(null);
  eflResults$ = this.eflResults.asObservable();

  setSelectedTopologyId(topologyId: string){
    this.selectedTopologyId.next(topologyId);
  }

  setAlarms(alarms: Array<Alarm>){
    this.alarms.next(alarms);
  }

  setDistinctTopologyIds(topologyIds: Array<string>){
    this.distinctTopologyIds.next(topologyIds);
  }

  setSidebarOpen(isOpen: boolean) {
    this.sidebarOpen.next(isOpen);
  }

  getSidebarOpen() {
    return this.sidebarOpen.getValue();
  }

  setEflResults(eflResults: Array<EflResult>){
    console.log("here we set efl resutls: ", eflResults);
    this.eflResults.next(eflResults);
  }

  getEflResults(){
    return this.eflResults.getValue();
  }

  getOverallResults(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/all");
  }

  getGmonResults(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/gmon/" + topologyId);
  }

  getLaResults(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/la/" + topologyId);
  }

  getPlanningResults(): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/allPlanning");
  }

  // Endpoint to get GMON planning results
  // URL: GET localhost:7777/icg/v1/rest/application/overview/gmonPlanning/{topologyId}
  getGmonPlanninResults(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/gmonPlanning/" + topologyId);
  }

  // Endpoint to get LA planning results
  // URL: GET localhost:7777/icg/v1/rest/application/overview/laPlanning/{topologyId}
  getLaPlanningResults(topologyId: string): Observable<any> { 
    return this.httpClient.get(environment.API_BASE_URL + "application/overview/laPlanning/" + topologyId);
  }

  getAlarms(topologyId: string): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "getAllAlarms/" + topologyId);
  }

  getEflDataForTopology(topologyId: string): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "application/efl/" + topologyId);
  }
}
